import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
    CmpsConfirmDialogComponent,
    CmpsConfirmDialogOptions,
    CmpsDialog,
    CmpsDialogRef,
} from '@cmps/ng-uikit';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { navigateToNewUser } from '../../coaching-detail/navigate';

import { TranslationKeyMap } from './new-transcript-dialog.i18n';

@Injectable({ providedIn: 'root' })
export class CoachingNewTranscriptDialogService {
    constructor(
        private readonly _router: Router,
        private readonly _translateService: TranslateService,
        private readonly _dialog: CmpsDialog,
    ) {}

    createDialog(params: URLSearchParams): {
        ref: CmpsDialogRef<CmpsConfirmDialogComponent, any>;
        obs: Observable<boolean>;
    } {
        const username = params.get('username');
        const userId = parseInt(params.get('userId'));
        const coachingCommand = params.get('coachingCommand');

        const data: CmpsConfirmDialogOptions = {
            title: this._translateService.instant(
                TranslationKeyMap._10032_NEW_TRANSCRIPT,
            ),
            message: this._translateService.instant(
                TranslationKeyMap._10033_A_NEW_TRANSCRIPT_IS_READY_FOR___USERNAME__,
                { userName: username },
            ),
            actions: [
                {
                    label: this._translateService.instant(
                        TranslationKeyMap._789_VIEW,
                    ),
                    data: 0,
                },
                {
                    label: this._translateService.instant(
                        TranslationKeyMap._10034_DISMISS,
                    ),
                    data: 1,
                },
            ],
        };
        const ref = this._dialog.open(CmpsConfirmDialogComponent, {
            disableClose: true,
            data,
        });
        const obs = ref.result.pipe(
            switchMap((ret) => {
                if (ret === 0) {
                    void navigateToNewUser(this._router, userId, {
                        coachingCommand,
                    });
                }
                return of(ret === 0);
            }),
        );
        return { ref, obs };
    }
}
